import { render, staticRenderFns } from "./BasicSelect.vue?vue&type=template&id=cabc2c9e&scoped=true"
import script from "./BasicSelect.vue?vue&type=script&lang=js"
export * from "./BasicSelect.vue?vue&type=script&lang=js"
import style0 from "semantic-ui-dropdown/dropdown.css?vue&type=style&index=0&id=cabc2c9e&prod&scoped=true&lang=css&external"
import style1 from "./BasicSelect.vue?vue&type=style&index=1&id=cabc2c9e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cabc2c9e",
  null
  
)

export default component.exports